'use strict';

var _classCallCheck = require("/Users/vedantvyas/chromafan-web/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/Users/vedantvyas/chromafan-web/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/vedantvyas/chromafan-web/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/vedantvyas/chromafan-web/node_modules/@babel/runtime/helpers/inherits");

var _wrapNativeSuper = require("/Users/vedantvyas/chromafan-web/node_modules/@babel/runtime/helpers/wrapNativeSuper");

var pLimit = require('p-limit');

var EndError =
/*#__PURE__*/
function (_Error) {
  _inherits(EndError, _Error);

  function EndError(value) {
    var _this;

    _classCallCheck(this, EndError);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(EndError).call(this));
    _this.value = value;
    return _this;
  }

  return EndError;
}(_wrapNativeSuper(Error)); // the input can also be a promise, so we `Promise.all()` them both


var finder = function finder(el) {
  return Promise.all(el).then(function (val) {
    return val[1] === true && Promise.reject(new EndError(val[0]));
  });
};

module.exports = function (iterable, tester, opts) {
  opts = Object.assign({
    concurrency: Infinity,
    preserveOrder: true
  }, opts);
  var limit = pLimit(opts.concurrency); // start all the promises concurrently with optional limit

  var items = Array.from(iterable).map(function (el) {
    return [el, limit(function () {
      return Promise.resolve(el).then(tester);
    })];
  }); // check the promises either serially or concurrently

  var checkLimit = pLimit(opts.preserveOrder ? 1 : Infinity);
  return Promise.all(items.map(function (el) {
    return checkLimit(function () {
      return finder(el);
    });
  })).then(function () {}).catch(function (err) {
    return err instanceof EndError ? err.value : Promise.reject(err);
  });
};